<div class="ativacao-wrapper">
    <app-alert-card
        class="ativacao-alert"
        [type]="isAtivo ? 'success' : 'neutral'"
        [title]="tituloAlerta"
        [icon]="isAtivo ? 'check_circle' : 'radio_button_unchecked'">
        {{ isAtivo ? descricaoAtivo : descricaoInativo }}
        <mat-slide-toggle alertActions class="app-toggle-compact" [formControl]="control"
            (change)="ativacaoChange.emit($event.checked)">
        </mat-slide-toggle>
    </app-alert-card>

    @if (!isAtivo) {
    <app-empty-state
        [icon]="emptyStateIcone"
        [title]="emptyStateTituloTexto"
        [subtitle]="emptyStateDescricaoTexto">
    </app-empty-state>
    }
</div>
